<div class="jumbotron-fluid text-center" [@fadeInOut]>
    <h2 class="font-weight-light card-title h2">Legal Ad Review Form</h2>
    <p class="font-weight-bold caption">Submit or Review A New Legal Ad Review Form</p>
    <hr class="ml-5 mr-5"/>
    <button type="button" class="btn btn-outline-light my-2 z-depth-0" data-toggle="modal" data-target="#assistanceModal">Click here for assistance</button>
</div>
<!-- Modal -->
<div class="modal fade" id="assistanceModal" tabindex="-1" role="dialog" aria-labelledby="assistanceModalTitle" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="assistanceModalTitle">Contact Information</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        If you have any questions regarding the submission of this form, please contact:
        <br/><br/> 
        <a href="mailto:legaladreview@pulte.com" target="_top">Shani Pipkin, Manager Legal Operations</a>
        <br/>
        <span>Office: (949) 330-8555
            <a href="tel:949-330-8555" ><img class="skype-icon" title="Call: (949) 330-8555" src=".\assets\skype-icon.png"/></a>
        </span>
        <br/><br/>  
        <a href="mailto:legaladreview@pulte.com" target="_top">Fredrikson & Byron Law Firm</a>
        <br/><br/>  
        <a href="mailto:legaladreview@pulte.com" target="_top">Andrew McBride, Corporate Counsel</a>
        <br/>
        <span>Office: (678) 455-5217
            <a href="tel:678-455-5217"><img class="skype-icon" title="Call: (678) 455-5217" src=".\assets\skype-icon.png"/></a>
        </span>
        <br/><br/> 
        If you need to delete a form, please send an email with your request to <a href="mailto:legaladreview@pulte.com" target="_top">legaladreview&#64;pulte.com</a>.
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<hr class="ml-5 mr-5"/>